import http from "@/http";
import { CAMPANHA_ENDPOINTS } from "../constantes/endpoints";

class VerificarPendenciaService {
  async verificar(cdCooperado) {
    try {
      const endpoint = CAMPANHA_ENDPOINTS.VERIFICAR_PENDENCIA(cdCooperado);
      const response = await http.get(endpoint);
      const payload = response.data || {};
      const data = payload.data || {};
      const campanha = data.campanha || null;
      const origem = campanha || data;
      const pendencia = origem?.pendencia ? Number(origem.pendencia) : null;
      const temPendencia =
        data.temPendencia !== undefined
          ? Boolean(data.temPendencia)
          : data.tem_pendencia !== undefined
          ? Boolean(data.tem_pendencia)
          : Boolean(pendencia || payload.hasPendencia);

      return {
        success: payload.status !== false,
        status: payload.status !== false,
        hasPendencia: temPendencia,
        tipoPendencia: origem?.tipo_pendencia || null,
        pendencia,
        mensagem: origem?.mensagem || "",
        cdCooperado,
        data: {
          ...data,
          temPendencia,
          campanha,
          cdCooperado,
          cdProced: pendencia
        }
      };
    } catch (error) {
      return {
        success: false,
        hasPendencia: false,
        error: error.response?.data?.message || error.message
      };
    }
  }
}

export const verificarPendenciaService = new VerificarPendenciaService();
